import * as URLConfig from "../domain";

const config = URLConfig.config;

const myAppsUrlConfig = {
  myApps: config.jmw + config.jmw_login + "myapps/",
  myAppsV1: config.jmw + config.jmw_login + "myapps/v1/",
  appIcon: config.rootUrl + "EWWebImages/WebImages/",
  // Vendor's config
  mySubscription: config.jmw + config.jmw_content + "mysubscription/",
  mySubscriptionV1: config.jmw + config.jmw_content + "mysubscription/v1/",
  downloadReports:
    config.jmw +
    config.jmw_content +
    "mysubscription/analytics/report/download",
};

export default myAppsUrlConfig;
